// services/inquiryService.js

const API_BASE_URL = 'http://staging.maamaas.com:8080/protohub/api';

const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const inquiryService = {
  // Get all inquiries
  getAllInquiries: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/user/enquiry/getAll`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await handleResponse(response);
    } catch (error) {
      console.error('Error fetching inquiries:', error);
      throw error;
    }
  },

  // Get inquiry by ID
  getInquiryById: async (inquiryId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/user/enquiry/${inquiryId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await handleResponse(response);
    } catch (error) {
      console.error(`Error fetching inquiry ${inquiryId}:`, error);
      throw error;
    }
  },

  // Get inquiries by status
  getInquiriesByStatus: async (status) => {
    try {
      const response = await fetch(`${API_BASE_URL}/user/enquiry/status/${status}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await handleResponse(response);
    } catch (error) {
      console.error(`Error fetching inquiries with status ${status}:`, error);
      throw error;
    }
  },

  // Create inquiry
  createInquiry: async (inquiryData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/user/enquiry/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inquiryData),
      });
      return await handleResponse(response);
    } catch (error) {
      console.error('Error creating inquiry:', error);
      throw error;
    }
  },

  // Update inquiry
  updateInquiry: async (inquiryId, updateData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/user/enquiry/${inquiryId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
      });
      return await handleResponse(response);
    } catch (error) {
      console.error(`Error updating inquiry ${inquiryId}:`, error);
      throw error;
    }
  },

  // Delete inquiry
  deleteInquiry: async (inquiryId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/user/enquiry/${inquiryId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await handleResponse(response);
    } catch (error) {
      console.error(`Error deleting inquiry ${inquiryId}:`, error);
      throw error;
    }
  }
};

export default inquiryService;